module.exports = __webpack_public_path__ + "img/免费领取.76c101f6.gif";